import React from "react"
import styled from "styled-components"
import Img from "gatsby-image"
import Box from "@material-ui/core/Box"
import StaticParagraph from "./StaticParagraph"

const StyledImg = styled(Img)`
  width: 100%;
  margin: 1rem auto;
`
const StyledBox = styled(Box)`
  width: 100%;
  margin: 1rem auto;
  margin-bottom: 2rem;
  ${props => props.theme.breakpoints.up("md")} {
    margin-bottom: 4.5rem;
  }
`

export default function StaticImage(props) {
  return (
    <StyledBox>
      <StyledImg {...props} />
      {props.copyright && (
        <StaticParagraph variant="caption">{props.copyright}</StaticParagraph>
      )}
    </StyledBox>
  )
}
